import React from 'react';
import { LucideIcon } from 'lucide-react';

interface Props {
  title: string;
  value: React.ReactNode;
  subtitle?: string;
  icon: LucideIcon;
  trend?: {
    value: number;
    isPositive: boolean;
  };
  color?: 'blue' | 'green' | 'purple' | 'orange' | 'red' | 'affinicar';
}

const COLOR_CLASSES = {
  blue: 'tw-bg-blue-100 tw-text-blue-600',
  green: 'tw-bg-green-100 tw-text-green-600',
  purple: 'tw-bg-purple-100 tw-text-purple-600',
  orange: 'tw-bg-orange-100 tw-text-orange-600',
  red: 'tw-bg-red-100 tw-text-red-600',
  affinicar: 'tw-bg-affinicar-lighter tw-text-affinicar-primary',
};

export const KpiCard: React.FC<Props> = ({
  title,
  value,
  subtitle,
  icon: Icon,
  trend,
  color = 'blue',
}) => {
  return (
    <div className="tw-bg-white tw-border tw-border-gray-200 tw-rounded-lg tw-p-4 md:tw-p-6 hover:tw-shadow-md tw-transition-shadow">
      <div className="tw-flex tw-items-start tw-justify-between">
        <div className="tw-flex-1 tw-min-w-0">
          <p className="tw-text-sm sm:tw-text-base tw-font-semibold tw-text-gray-900 tw-mb-1">{title}</p>
          <p className="tw-text-xl sm:tw-text-2xl md:tw-text-3xl tw-font-bold tw-text-gray-900 tw-mb-1 tw-truncate">{value}</p>
          {subtitle && <p className="tw-text-xs sm:tw-text-sm tw-text-gray-500 tw-mb-0">{subtitle}</p>}
          {trend && (
            <p className={`tw-text-sm tw-mt-2 ${trend.isPositive ? 'tw-text-green-600' : 'tw-text-red-600'}`}>
              {trend.isPositive ? '↑' : '↓'} {Math.abs(trend.value)}%
            </p>
          )}
        </div>
        <div className={`tw-p-2 md:tw-p-3 tw-rounded-lg ${COLOR_CLASSES[color]}`}>
          <Icon className="tw-w-5 sm:tw-w-6 tw-h-5 sm:tw-h-6" />
        </div>
      </div>
    </div>
  );
};
